module.exports = __webpack_public_path__ + "static/confetti-stamps-small-bf18e349873f67120ed79b2f16a3c5ab.svg";